export default __webpack_public_path__ + "static/media/book.ad73f8be.webp";